import * as React from "react";
import DeletableChip from "~/components/Chips/DeletableChip";
import { MultiSelect } from "~/components/MultiSelect/MultiSelect";
import type { FormFieldProps } from "~/components/form";
import type { ComponentProps } from "~/utils/types";
interface CustomFieldScopeMultiSelectProps extends FormFieldProps<string[]> {
    items: {
        Id: string;
        Name: string;
    }[];
    autoFocus?: boolean;
    label?: string | JSX.Element;
    error?: string;
    accessibleName?: string;
    renderChip?: (item: {
        Id: string;
        Name: string;
    }, onRequestDelete: () => void) => JSX.Element;
}
const CustomFieldScopeTypedMultiSelect = MultiSelect<{
    Id: string;
    Name: string;
}>();
type RenderChip = ComponentProps<typeof CustomFieldScopeTypedMultiSelect>["renderChip"];
export const CustomFieldScopeMultiSelect: React.FC<CustomFieldScopeMultiSelectProps> = (props) => {
    const defaultChipRenderer: RenderChip = (item, onRequestDelete: () => void) => {
        return (<DeletableChip description={`${item.Id}: ${item.Name}`} key={item.Id} onRequestDelete={onRequestDelete} deleteButtonAccessibleName={`Remove ${item.Name}`}>
                {item.Name}
            </DeletableChip>);
    };
    const chipRenderer = props.renderChip || defaultChipRenderer;
    return <CustomFieldScopeTypedMultiSelect fieldName="custom field scopes" renderChip={chipRenderer} accessibleName={props.accessibleName} {...props} items={props.items}/>;
};
CustomFieldScopeMultiSelect.displayName = "CustomFieldScopeMultiSelect"
export const SupportedCustomFieldScopes = ["Tenant", "Environment"];
